module.exports = __webpack_public_path__ + "static/img/award3.7d39fc6.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/index/award3.png
// module id = BKoT
// module chunks = 7